import { render } from "./CTabs.vue?vue&type=template&id=7b51ae00&scoped=true&ts=true"
import script from "./CTabs.vue?vue&type=script&lang=ts"
export * from "./CTabs.vue?vue&type=script&lang=ts"

import "./CTabs.vue?vue&type=style&index=0&id=7b51ae00&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b51ae00"]])

export default __exports__